export const PPLPrefix =
  process.env.REACT_APP_ENV === "production"
    ? "wingspan.me/"
    : "staging.wingspan.me/";

export const createPPL = (
  tag: string,
  options?: { includeProtocol?: boolean }
) => {
  return (options?.includeProtocol ? "https://" : "") + PPLPrefix + tag;
};
